<template>
  <ButtonComponent
    :icon="['fal', 'low-vision']"
    :label="label"
    v-on="$listeners"
    class="shop-conditions-input"
    :class="{ 'shop-conditions-input--empty': !this.conditions.length }"
  />
</template>

<script>
export default {
  props: {
    value: Object,
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    conditions() {
      return [...this.value.if, ...this.value.ifnot]
    },
    label() {
      if (!this.showLabel) return
      if (this.conditions.length)
        return this.$tc('xActiveConditions', this.conditions.length, { count: this.conditions.length })

      return this.$t('setConditions') + '...'
    },
  },
}
</script>

<style lang="scss">
.shop-conditions-input {
  &--empty {
    .elder-button__label {
      opacity: 0.7;
    }
  }
}
</style>
